import { getGlobalConfigs } from '@/utils/site-utils';

/**
 * 脚本加载服务
 * 用于管理外部脚本的异步加载
 */
class ScriptLoaderService {
  constructor() {
    this.loadedScripts = new Set();
    this.loadingPromises = new Map();
  }

  /**
   * 加载Finance脚本
   * @param {Function} onLoadCallback 脚本加载完成后的回调函数
   * @param {Object} page 页面对象，用于获取配置
   * @returns {Promise} 加载Promise
   */
  loadFinanceScript(onLoadCallback = null, page = null) {
    // 从全局配置获取calculatorKey
    const [calculatorKey] = getGlobalConfigs(page, 'calculatorKey');
    const scriptUrl = calculatorKey.value;
    const scriptKey = 'finance-script';

    // 如果已经加载过，直接返回resolved Promise并执行回调
    if (this.loadedScripts.has(scriptKey)) {
      if (onLoadCallback && typeof onLoadCallback === 'function') {
        onLoadCallback();
      }
      return Promise.resolve();
    }

    // 如果正在加载中，返回现有的Promise
    if (this.loadingPromises.has(scriptKey)) {
      return this.loadingPromises.get(scriptKey);
    }

    // 检查DOM中是否已存在该脚本
    if (document.querySelector('script[src*="plugins.codeweavers.app"]')) {
      this.loadedScripts.add(scriptKey);
      if (onLoadCallback && typeof onLoadCallback === 'function') {
        onLoadCallback();
      }
      return Promise.resolve();
    }

    // 创建新的加载Promise
    const loadPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = scriptUrl;
      script.async = true;

      script.onload = () => {
        console.log('Finance script loaded successfully');
        this.loadedScripts.add(scriptKey);
        this.loadingPromises.delete(scriptKey);

        // 执行回调函数
        if (onLoadCallback && typeof onLoadCallback === 'function') {
          onLoadCallback();
        }

        resolve();
      };

      script.onerror = (error) => {
        console.error('Failed to load finance script:', error);
        this.loadingPromises.delete(scriptKey);
        reject(error);
      };

      document.head.appendChild(script);
    });

    this.loadingPromises.set(scriptKey, loadPromise);
    return loadPromise;
  }

  /**
   * 检查脚本是否已加载
   * @param {string} scriptKey 脚本标识
   * @returns {boolean}
   */
  isScriptLoaded(scriptKey) {
    return this.loadedScripts.has(scriptKey);
  }

  /**
   * 清理已加载的脚本记录
   * @param {string} scriptKey 脚本标识
   */
  clearScriptRecord(scriptKey) {
    this.loadedScripts.delete(scriptKey);
    this.loadingPromises.delete(scriptKey);
  }
}

// 创建单例实例
const scriptLoaderService = new ScriptLoaderService();

export default scriptLoaderService;
